/** @jsxImportSource @emotion/react */
import { FC } from 'react';
import { Selectable } from '@zip/business-components';
import { useMerchantApplicationContext } from 'contexts/MerchantApplication.context';
import {
  PaymentUseCaseProps,
  StepComponentProps,
} from 'types/interfaces/sign-up/MerchantApplication.types';
import { StepIndex } from '../signUpConfig';
import {
  SignUpRadioStepConfig,
  SignUpRadioStepForm,
  useSignUpRadioStep,
} from './useSignUpRadioStep.module';

const config: SignUpRadioStepConfig<PaymentUseCaseProps> = {
  stepIndex: StepIndex.PaymentUseCase,
  selectionField: 'paymentType',
  requiredSelectionMessage: 'Please select an option',
  initialValues: {
    paymentType: '',
  },
};

export const PaymentUseCaseStepModule: FC<StepComponentProps> = ({
  provideSubmit,
  serverErrors,
}) => {
  const { formOptions } = useMerchantApplicationContext();
  const options: Selectable[] = (formOptions.PaymentType ?? []).map(
    (answer) => ({ label: answer, value: answer })
  );
  const step = useSignUpRadioStep(config, options, {
    provideSubmit,
    serverErrors,
  });

  return <SignUpRadioStepForm {...step} />;
};

export default PaymentUseCaseStepModule;
